import { render, staticRenderFns } from "./category-levels-assessment.vue?vue&type=template&id=1593540c&"
import script from "./category-levels-assessment.vue?vue&type=script&lang=ts&"
export * from "./category-levels-assessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports